var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.315789,
    y: 0.315789,
    width: 23.3684,
    height: 23.3684,
    rx: 4.73684,
    stroke: "#F7931A",
    strokeWidth: 0.631579
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.392 6.31579C15.6768 6.31579 15.8996 6.67187 15.7315 6.92799C14.5778 8.68226 13.4999 9.42058 12.3462 11.1742C12.1774 11.431 11.8354 11.4342 11.6666 11.1775C10.5129 9.4232 9.43096 8.69663 8.27725 6.94171C8.19222 6.81299 8.19544 6.6869 8.24826 6.58497C8.29593 6.43731 8.42605 6.31579 8.64121 6.31579L15.392 6.31579Z",
    fill: "#F7931A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.392 12.6316C15.6768 12.6316 15.8996 12.9877 15.7315 13.2438C14.5778 14.998 13.4999 15.7364 12.3462 17.49C12.1774 17.7468 11.8354 17.75 11.6666 17.4933C10.5129 15.739 9.43096 15.0124 8.27725 13.2575C8.19222 13.1288 8.19544 13.0027 8.24826 12.9008C8.29593 12.7531 8.42605 12.6316 8.64121 12.6316L15.392 12.6316Z",
    fill: "#F7931A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.278412327c72566ccd32aabc2026ee65.svg";
export { ForwardRef as ReactComponent };